import { render, staticRenderFns } from "./facturelibre.vue?vue&type=template&id=455c9820&scoped=true"
import script from "./facturelibre.vue?vue&type=script&lang=js"
export * from "./facturelibre.vue?vue&type=script&lang=js"
import style0 from "./facturelibre.vue?vue&type=style&index=0&id=455c9820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c9820",
  null
  
)

export default component.exports